module.exports = __webpack_public_path__ + "img/welcomenew.ec529014.png";